import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="inpost"
export default class extends Controller {
  static targets = [
    "geowidget",
    "paczkomatId",
    "paczkomatIdContainer",
    "shippingMethodContainer",
  ];

  connect() {
    this.handlePointSelect = this.handlePointSelect.bind(this);
    document.addEventListener("onpointselect", this.handlePointSelect);
    const selectedRadio = this.shippingMethodContainerTarget.querySelector(
      'input[type="radio"]:checked',
    );
    if (selectedRadio) {
      const event = new Event("change");
      selectedRadio.dispatchEvent(event);
    }
  }

  disconnect() {
    document.removeEventListener("onpointselect", this.handlePointSelect);
  }

  handlePointSelect(event) {
    this.paczkomatIdTarget.value = event.detail.name;
    this.paczkomatIdTarget.classList.add("input-success");
    setTimeout(() => {
      this.paczkomatIdTarget.classList.remove("input-success");
    }, 1500);
    this.hideGeowidget();
  }

  hidePaczkomatInput() {
    this.paczkomatIdContainerTarget.style.display = "none";
  }

  showPaczkomatInput() {
    this.paczkomatIdContainerTarget.style.display = "block";
  }

  hideGeowidget() {
    this.geowidgetTarget.style.display = "none";
  }

  showGeowidget() {
    this.geowidgetTarget.style.display = "block";
  }

  change(event) {
    const parentText = event.target.parentElement.textContent;

    if (parentText.toLowerCase().includes("paczkomat")) {
      this.showGeowidget();
      this.showPaczkomatInput();
    } else {
      this.hideGeowidget();
      this.hidePaczkomatInput();
    }
  }
}
